export const COLORS = {
  PRIMARY_COLOR:"#FFFFFF",
  SECONDARY_COLOR:"#000000",
  BLACK:"#000000",
  WHITE:"#FFFFFF",
  LIGHT_GREY_1:"#F7F7F7",
  LIGHT_GREY_2:"#B4B4B4",
  LIGHT_GREY_3:"#C7C7C7",
  LIGHT_GREY_4:"#605F5F",
  DARK_GREY_1:"#221F20",
  DARK_GREY_2:"#181616",
  DARK_GREY_3:"#C7C7C7",
  DARK_GREY_4:"#383536",
}

export const TYPE = {
  SERIF_FONT: "Px Regular",
  SERIF_BOLD_FONT: "Px Bold",
  MONO_FONT:"Maison Mono",
}

